import React from 'react';

import OrchestratorImage from "../../../assets/Images/orchestrator.JPG"

function Orchestrator() {

    return (
        <img src={OrchestratorImage} alt="orchestrator"/>
    )
}

export default Orchestrator
